<template>
    <div class="popup popup--vue" v-bind:class="{'is-active': show}" @click.stop="cancel">
        <div class="popup__content" @click.stop="cancel">
            <div class="popup__header" @click.stop="">
                <div class="title-3">{{$t('components.AddToBasketPopup.title')}}</div>
            </div>
            <div class="popup__body py-8 text-center" @click.stop="">
                <button class="btn btn--popup btn--white mr-2 " @click.prevent="toShop">{{$t('components.AddToBasketPopup.toShop')}}</button>
                <button class="btn btn--popup btn--black " @click.prevent="toBasket">{{$t('components.AddToBasketPopup.toBasket')}}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['show'],
        watch: {
            show: function(newVal) {
                if(newVal) {
                    disable_scroll();
                } else {
                    enable_scroll();
                }
            }
        },
        methods: {
            cancel() {
                this.$emit('cancel');
            },
            toShop() {
                this.$emit('toShop')
            },
            toBasket() {
                this.$emit('toBasket');
            }
        }
    };
</script>
